import { InertiaLink } from '@inertiajs/inertia-react'
import LocalMallOutlinedIcon from '@mui/icons-material/LocalMallOutlined'
import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid'
import { styled } from '@mui/material/styles'
import { useTranslation } from 'react-i18next'

export default function Empty() {
  const { t } = useTranslation()

  const CustomContainer = styled(Grid)({
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  })

  return (
    <CustomContainer container item xs={12}>
      <LocalMallOutlinedIcon sx={{ fontSize: '250px !important' }} />
      <Button component={InertiaLink} href={route('partner.home')} sx={{ marginTop: '20px' }} variant="contained">
        {t('CART.ADD_NEW_VOUCHER')}
      </Button>
    </CustomContainer>
  )
}
